// ── SIGHTMARK SIDEBAR MEGA MENU TAB SWITCHER ──
document.addEventListener('DOMContentLoaded', function () {

  function initSidebarMega() {
    const tabs = document.querySelectorAll('.sm-sidebar-mega__tab');
    const panels = document.querySelectorAll('.sm-sidebar-mega__panel');

    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        switchTab(this);
      });
      tab.addEventListener('click', function () {
        switchTab(this);
      });
    });

    function switchTab(tab) {
      const target = tab.getAttribute('data-tab');

      tabs.forEach(function (t) {
        t.classList.remove('sm-sidebar-mega__tab--active');
      });
      panels.forEach(function (p) {
        p.classList.remove('sm-sidebar-mega__panel--active');
      });

      tab.classList.add('sm-sidebar-mega__tab--active');
      const panel = document.getElementById('sm-tab-' + target);
      if (panel) panel.classList.add('sm-sidebar-mega__panel--active');
    }
  }

  initSidebarMega();

  // Re-init if Shopify theme loads nav dynamically
  const observer = new MutationObserver(function () {
    if (document.querySelector('.sm-sidebar-mega__tab')) {
      initSidebarMega();
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

});

// ── PREVENT PRODUCTS LINK FROM NAVIGATING ──
document.addEventListener('click', function (e) {
  var path = e.composedPath();
  var link = path.find(function (el) {
    return el.dataset && el.dataset.noNav === 'true';
  });
  if (link) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}, true);

// ── SHOP BY TAB SWITCHER (Series / Features) ──
document.addEventListener('click', function (e) {
  var tab = e.target.closest('.sm-shopby__tab');
  if (!tab) return;

  var shopby = tab.getAttribute('data-shopby');
  var wrapper = tab.closest('.sm-sidebar-mega__panel');
  if (!wrapper) return;

  wrapper.querySelectorAll('.sm-shopby__tab').forEach(function (t) {
    t.classList.remove('sm-shopby__tab--active');
  });
  tab.classList.add('sm-shopby__tab--active');

  wrapper.querySelectorAll('.sm-shopby__panel').forEach(function (p) {
    p.classList.remove('sm-shopby__panel--active');
  });
  var panel = wrapper.querySelector('[data-shopby-panel="' + shopby + '"]');
  if (panel) panel.classList.add('sm-shopby__panel--active');
});